import { Text } from "../../Type";

const BooleanCell = ({ value }: { value: "Yes" | "No" | null }) => {
  if (value === null) {
    return <Text>-</Text>;
  }
  return <Text>{value ? "Yes" : "No"}</Text>;
};

export default BooleanCell;
